import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IndoorCalendarBootstrapComponent } from './indoor-calendar-bootstrap/indoor-calendar-bootstrap.component';

const routes: Routes = [
  { path: '', component: IndoorCalendarBootstrapComponent, pathMatch: 'full' }
];

// export const routing = RouterModule.forChild(routes);
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IndoorWorldSeriesCalendarRoutingModule {}
